import Order from "./Order";
import OrderLoader from "./OrderLoader.js";
import ErrorModal from "../../../common/ui/ErrorModal.js";
import OrderStatusNavigation from "../navigation/OrderStatusNavigation.js";
import {ReactComponent as S8PoweredByLogo} from "../../../images/S8PoweredLogo_Black.svg";

export default function OrderStatusPage(props) {
    const orderList = props.orderStatusDetails.OpenOrders.map((order) => {
        return (
            <Order 
                key={order.cartSummaryRecId} 
                order={order}
                urlConfig={props.urlConfig} 
            />
        )
    });

    return (
        <>
            <OrderStatusNavigation 
                handleStartNewOrderClickOrderStatus={props.handleStartNewOrderClickOrderStatus}
            />
            <div className="container-lg" style={{minHeight: "calc(100vh - 200px)"}}>
                {orderList.length > 0 ? orderList : <OrderLoader urlConfig={props.urlConfig} />}
            </div>
            <ErrorModal 
                errorModal={props.errorModal}
                handleCloseErrorModal={props.handleCloseErrorModal}
            />
            <div className="d-flex flex-row justify-content-center pt-4 pb-4">
                <a href="https://www.shift8.com/" target="_blank" rel="noreferrer">
                    <svg role="img" width="80px" height="28px" alt="Powered by Shift8" aria-labelledby="Powered by Shift8">
                        <title>Powered by Shift8</title>
                        <S8PoweredByLogo />
                    </svg>
                </a>
            </div>
        </>
    )
}